import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textvalues',
})
export class TextvaluesPipe implements PipeTransform {
  transform(value: string, args?: number[] | string[]): string {
    if (!value) {
      return value;
    }
    args?.forEach((arg, index) => {
      value = value.split(`%${index + 1}%`).join(arg.toString());
    });
    return value;
  }
}
